// import React, { useEffect, useMemo, useState } from 'react'
// import { useNavigate } from 'react-router-dom';
// import AdminSidebar from 'admin/sidebar/AdminSidebar';
// import axios from 'axios';
// import './Crm.css';

// const fmtAED = (n) => `AED ${Number(n || 0).toLocaleString('en-US', { maximumFractionDigits: 2 })}`;
// const fmtNum = (n) => Number(n || 0).toLocaleString('en-US');

// const API_BASE = process.env.REACT_APP_API_URL || 'https://production.washta.com';
// const ADMIN_BASE = `${API_BASE}/api/admin`;
// const DASHBOARD_V2_URL = `${API_BASE}/api/admin/v2/dashboard`;

// const EMPTY_KPIS = {
//    totalCustomers: 0,
//    active30d: 0,
//    atRisk: 0,
//    churned60d: 0,
//    newThisMonth: 0,
// };

// const getInitials = (name = '') => {
//    const parts = String(name).trim().split(/\s+/).filter(Boolean);
//    if (parts.length === 0) return 'NA';
//    return parts.slice(0, 2).map((part) => part[0]).join('').toUpperCase();
// };

// const toNumber = (value) => {
//    if (typeof value === 'number') return value;
//    const parsed = Number(value || 0);
//    return Number.isFinite(parsed) ? parsed : 0;
// };

// const formatDateLabel = (value) => {
//    if (!value) return '—';
//    const date = new Date(value);
//    if (Number.isNaN(date.getTime())) return '—';
//    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
// };

// const daysBetween = (older, newer) => {
//    if (!older || !newer) return null;
//    const diff = newer.getTime() - older.getTime();
//    if (!Number.isFinite(diff) || diff < 0) return null;
//    return Math.round(diff / (1000 * 60 * 60 * 24));
// };

// const deriveSegment = (daysSinceLastWash, totalOrders) => {
//    if (totalOrders >= 10) return { key: 'vip', label: 'VIP · 10+ washes', bg: '#f0eeff', color: '#4a3db8' };
//    if (daysSinceLastWash != null && daysSinceLastWash >= 60) return { key: 'churned', label: 'Churned · 60d+', bg: '#fee2e2', color: '#991b1b' };
//    if (daysSinceLastWash != null && daysSinceLastWash >= 21) return { key: 'at-risk', label: 'At Risk · 21d+', bg: '#fef3c7', color: '#92400E' };
//    return { key: 'active', label: 'Active · 30d', bg: '#e0f2ea', color: '#1a6641' };
// };

// const buildCustomerRows = (orders = []) => {
//    const byCustomer = new Map();

//    orders.forEach((order) => {
//       const customer = order.customerId || {};
//       const customerId = customer._id || order.customerId?._id || order.customerId;
//       if (!customerId) return;

//       const customerName = customer.username || customer.fullName || customer.fullname || customer.name || order.customerName || 'Unknown Customer';
//       const customerEmail = customer.email || order.customerEmail || '—';

//       const createdAt = new Date(order.createdAt || order.date || Date.now());
//       const current = byCustomer.get(String(customerId)) || {
//          id: String(customerId),
//          name: customerName,
//          email: customerEmail,
//          avatar: customer.avatar || customer.resizedAvatar || '',
//          vehicle: order.vehicleId?.vehicleName || order.vehicleId?.vehicleModel || order.vehicleId?.vehicleManufacturer || order.vehicleName || '—',
//          plate: order.vehicleId?.vehiclePlateNumber || order.plate || '—',
//          carType: order.vehicleId?.vehicleType || order.vehicleId?.vehicleModel || order.vehicleId?.vehicleManufacturer || order.vehicleType || '—',
//          city: order.serviceLocation?.city || order.serviceLocation?.text || order.shopId?.location?.text || '—',
//          washes: 0,
//          totalSpend: 0,
//          dates: [],
//          services: new Map(),
//       };

//       current.washes += 1;
//       current.totalSpend += toNumber(order.cost || order.finalCost || order.shopPrice || 0);
//       current.dates.push(createdAt);

//       current.name = customerName || current.name;
//       current.email = customerEmail || current.email;

//       if (order.vehicleId) {
//          current.vehicle = order.vehicleId.vehicleName || order.vehicleId.vehicleModel || current.vehicle;
//          current.plate = order.vehicleId.vehiclePlateNumber || current.plate;
//          current.carType = order.vehicleId.vehicleType || current.carType;
//       }

//       const serviceName = order.serviceName || order.shopId?.service || order.serviceVariant?.variantName || 'Other';
//       current.services.set(serviceName, (current.services.get(serviceName) || 0) + 1);
//       byCustomer.set(String(customerId), current);
//    });

//    return Array.from(byCustomer.values())
//       .map((customer) => {
//          const sortedDates = customer.dates.sort((a, b) => a.getTime() - b.getTime());
//          const lastWashDate = sortedDates[sortedDates.length - 1] || null;
//          const gaps = [];
//          for (let i = 1; i < sortedDates.length; i++) {
//             const gap = daysBetween(sortedDates[i - 1], sortedDates[i]);
//             if (gap != null) gaps.push(gap);
//          }
//          const avgIntervalDays = gaps.length ? Math.round(gaps.reduce((sum, gap) => sum + gap, 0) / gaps.length) : null;
//          const daysSinceLastWash = lastWashDate ? daysBetween(lastWashDate, new Date()) : null;
//          const segment = deriveSegment(daysSinceLastWash, customer.washes);
//          const topService = Array.from(customer.services.entries()).sort((a, b) => b[1] - a[1])[0]?.[0] || '—';

//          return {
//             id: customer.id,
//             initials: getInitials(customer.name),
//             avatarBg: segment.bg,
//             avatarColor: segment.color,
//             name: customer.name,
//             email: customer.email,
//             vehicle: customer.vehicle,
//             plate: customer.plate,
//             carType: customer.carType,
//             city: customer.city,
//             washes: customer.washes,
//             avgIntervalDays,
//             lastWash: formatDateLabel(lastWashDate),
//             lifetimeSpend: customer.totalSpend,
//             preferredService: topService,
//             segment: segment.key,
//             segmentLabel: segment.label,
//             lastWashDays: daysSinceLastWash,
//          };
//       })
//       .sort((a, b) => b.lifetimeSpend - a.lifetimeSpend);
// };

// const RATING_THRESHOLD = 4.0;

// // Build real fleet profile from orders
// const buildFleetProfile = (orders = []) => {
//    const counts = {};
//    orders.forEach((order) => {
//       const v = order.vehicleId;
//       if (!v) return;
//       const make = v.vehicleManufacturer || '';
//       const model = v.vehicleName || v.vehicleModel || '';
//       const label = [make, model].filter(Boolean).join(' ').trim() || 'Unknown';
//       counts[label] = (counts[label] || 0) + 1;
//    });
//    const total = Object.values(counts).reduce((s, n) => s + n, 0);
//    if (total === 0) return [];
//    return Object.entries(counts)
//       .sort((a, b) => b[1] - a[1])
//       .slice(0, 6)
//       .map(([label, count]) => ({
//          label,
//          count,
//          sharePct: Math.round((count / total) * 100),
//          widthPct: Math.round((count / total) * 100),
//       }));
// };

// // Build real car type distribution
// const buildCarTypeSplit = (orders = []) => {
//    const counts = {};
//    orders.forEach((order) => {
//       const type = order.vehicleId?.vehicleType || 'Unknown';
//       counts[type] = (counts[type] || 0) + 1;
//    });
//    const total = Object.values(counts).reduce((s, n) => s + n, 0);
//    if (total === 0) return [];
//    return Object.entries(counts)
//       .sort((a, b) => b[1] - a[1])
//       .slice(0, 6)
//       .map(([label, count]) => ({
//          label,
//          count,
//          pct: Math.round((count / total) * 100),
//       }));
// };

// // ── Skeleton loader — mirrors the real page layout ───────────────────
// const CrmSkeleton = () => (
//    <div style={{ display: 'flex', width: '100%' }}>
//       <div className="ws-view-block" style={{ flex: 1, minWidth: 0 }}>
//          <div className="ws-skel ws-skel-title"></div>
//          <div className="ws-skel ws-skel-sub"></div>

//          <div className="ws-kpi-strip ws-kpi-4">
//             {Array.from(new Array(4)).map((_, i) => (
//                <div className="ws-kpi-card" key={i}>
//                   <div className="ws-skel ws-skel-line-sm"></div>
//                   <div className="ws-skel ws-skel-line-lg" style={{ marginTop: 8 }}></div>
//                   <div className="ws-skel ws-skel-line-sm" style={{ marginTop: 8, width: '70%' }}></div>
//                </div>
//             ))}
//          </div>

//          <div style={{ display: 'flex', gap: 7, marginBottom: 14 }}>
//             {Array.from(new Array(4)).map((_, i) => (
//                <div key={i} className="ws-skel ws-skel-pill"></div>
//             ))}
//          </div>

//          <div className="ws-skel ws-skel-block" style={{ height: 260 }}></div>
//       </div>
//       <div className="ws-right-panel">
//          <div className="ws-skel ws-skel-line-sm" style={{ width: 70, marginBottom: 10 }}></div>
//          {Array.from(new Array(4)).map((_, i) => (
//             <div key={i} className="ws-skel ws-skel-line-md" style={{ marginBottom: 6 }}></div>
//          ))}
//       </div>
//    </div>
// );

// const Crm = () => {
//    const navigate = useNavigate();
//    const [loading, setLoading] = useState(true);
//    const [kpis, setKpis] = useState(EMPTY_KPIS);
//    const [customers, setCustomers] = useState([]);
//    const [fleetProfile, setFleetProfile] = useState([]);
//    const [carTypeSplit, setCarTypeSplit] = useState([]);
//    const [rawOrders, setRawOrders] = useState([]);
//    const [segmentFilter, setSegmentFilter] = useState('All Segments');
//    const [carTypeFilter, setCarTypeFilter] = useState('All Car Types');
//    const [cityFilter, setCityFilter] = useState('All Cities');
//    const [search, setSearch] = useState('');

//    useEffect(() => {
//       window.scrollTo(0, 0);

//       const fetchData = async () => {
//          try {
//             setLoading(true);
//             const token = localStorage.getItem('accessTokenAdmin');
//             if (!token) {
//                navigate('/');
//                return;
//             }

//             const headers = { Authorization: `Bearer ${token}` };
//             const [customerStatsRes, ordersRes] = await Promise.all([
//                axios.get(`${DASHBOARD_V2_URL}/customers`, { headers }).catch(() => null),
//                axios.get(`${ADMIN_BASE}/orders?limit=500`, { headers }).catch(() => null),
//             ]);

//             const stats = customerStatsRes?.data?.data?.kpis || {};
//             setKpis({
//                totalCustomers: toNumber(stats.totalCustomers?.value),
//                active30d: toNumber(stats.activeCustomers?.value),
//                atRisk: toNumber(stats.atRiskCustomers?.value),
//                churned60d: toNumber(stats.churnedCustomers?.value),
//                newThisMonth: 0,
//             });

//             const liveCustomers = buildCustomerRows(ordersRes?.data?.data || ordersRes?.data || []);
//             const orders = ordersRes?.data?.data || ordersRes?.data || [];
//             setCustomers(liveCustomers);
//             setRawOrders(orders);
//             setFleetProfile(buildFleetProfile(orders));
//             setCarTypeSplit(buildCarTypeSplit(orders));
//          } catch (error) {
//             console.error('Error loading CRM data:', error);
//          } finally {
//             setLoading(false);
//          }
//       };

//       fetchData();
//    }, []);

//    const segmentOptions = ['All Segments', 'Active · 30d', 'At Risk · 21d+', 'Churned · 60d+', 'VIP · 10+ washes'];
//    const carTypeOptions = useMemo(
//       () => ['All Car Types', ...Array.from(new Set(customers.map((c) => c.carType).filter(Boolean)))],
//       [customers]
//    );
//    const cityOptions = useMemo(
//       () => ['All Cities', ...Array.from(new Set(customers.map((c) => c.city).filter(Boolean)))],
//       [customers]
//    );

//    const segmentKeyMap = {
//       'Active · 30d': 'active',
//       'At Risk · 21d+': 'at-risk',
//       'Churned · 60d+': 'churned',
//       'VIP · 10+ washes': 'vip',
//    };

//    const filteredCustomers = useMemo(() => {
//       return customers
//          .filter((c) => segmentFilter === 'All Segments' || c.segment === segmentKeyMap[segmentFilter])
//          .filter((c) => carTypeFilter === 'All Car Types' || c.carType === carTypeFilter)
//          .filter((c) => cityFilter === 'All Cities' || c.city === cityFilter)
//          .filter((c) => {
//             if (!search.trim()) return true;
//             const q = search.trim().toLowerCase();
//             return c.name.toLowerCase().includes(q) || c.email.toLowerCase().includes(q) || c.plate.toLowerCase().includes(q);
//          });
//    }, [customers, segmentFilter, carTypeFilter, cityFilter, search]);

//    const segmentSummary = useMemo(() => {
//       const grouped = customers.reduce((acc, customer) => {
//          acc[customer.segment] = (acc[customer.segment] || 0) + 1;
//          return acc;
//       }, {});

//       return [
//          { key: 'active', label: 'Active · 30d', count: grouped.active || 0, bg: '#e0f2ea', color: '#1a6641' },
//          { key: 'at-risk', label: 'At Risk · 21d+', count: grouped['at-risk'] || 0, bg: '#fef3c7', color: '#92400E' },
//          { key: 'churned', label: 'Churned · 60d+', count: grouped.churned || 0, bg: '#fee2e2', color: '#991b1b' },
//          { key: 'vip', label: 'VIP · 10+ washes', count: grouped.vip || 0, bg: '#f0eeff', color: '#4a3db8' },
//       ];
//    }, [customers]);

//    const exportSegmentCSV = () => {
//       const header = ['Customer', 'Email', 'Vehicle', 'Plate', 'Car Type', 'City', 'Washes', 'Avg Interval (days)', 'Last Wash', 'Lifetime Spend', 'Preferred Service', 'Segment'];
//       const lines = filteredCustomers.map((c) => [
//          c.name, c.email, c.vehicle, c.plate, c.carType, c.city, c.washes,
//          c.avgIntervalDays ?? '—', c.lastWash, c.lifetimeSpend, c.preferredService, c.segmentLabel,
//       ]);
//       const csv = [header, ...lines].map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(',')).join('\n');
//       const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
//       const url = URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = 'washta-crm-segment.csv';
//       a.click();
//       URL.revokeObjectURL(url);
//    };

//    const notifyAtRisk = () => {
//       alert(`Notify ${kpis.atRisk} at-risk customers — hook this up to your notifications API.`);
//    };

//    const exportVIP = () => {
//       const vipCustomers = customers.filter((c) => c.segment === 'vip');
//       const header = ['Customer', 'Email', 'Washes', 'Lifetime Spend'];
//       const lines = vipCustomers.map((c) => [c.name, c.email, c.washes, c.lifetimeSpend]);
//       const csv = [header, ...lines].map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(',')).join('\n');
//       const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
//       const url = URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = 'washta-vip-list.csv';
//       a.click();
//       URL.revokeObjectURL(url);
//    };

//    const segmentPillClass = (segment) => {
//       if (segment === 'active') return 'ws-p-active';
//       if (segment === 'at-risk') return 'ws-p-pending';
//       return 'ws-p-refund';
//    };

//    return (
//       <div className='mainDiv-all-sideBar'>
//          <div className='div-sidebar'>
//             <AdminSidebar />
//          </div>
//          <div className='div-Dashbaord' style={{ padding: 0 ,background:'white'}}>
//             <div className="dashboard ws-crm-dashboard">
//                {loading ? (
//                   <CrmSkeleton />
//                ) : (
//                   <div style={{ display: 'flex', width: '100%', minWidth: 0 }}>
//                      {/* ── Main column ── */}
//                      <div className="ws-view-block" style={{ flex: 1, minWidth: 0 }}>
//                         <div className="ws-view-title">Customer CRM</div>
//                         <div className="ws-view-sub">
//                            Platform-wide customer intelligence. Churn signals based on each customer's personal wash
//                            interval baseline — not a fixed threshold.
//                         </div>

//                         <div className="ws-kpi-strip ws-kpi-4">
//                            <div className="ws-kpi-card ws-hl">
//                               <div className="ws-kpi-label">Total Customers</div>
//                                  <div className="ws-kpi-val ws-purple">{fmtNum(kpis.totalCustomers)}</div>
//                                  <div className="ws-kpi-delta ws-up">Live from customer intelligence API</div>
//                            </div>
//                            <div className="ws-kpi-card ws-gr">
//                               <div className="ws-kpi-label">Active (30d)</div>
//                                  <div className="ws-kpi-val ws-green">{fmtNum(kpis.active30d)}</div>
//                                  <div className="ws-kpi-delta">{kpis.totalCustomers ? Math.round((kpis.active30d / kpis.totalCustomers) * 100) : 0}% of base</div>
//                            </div>
//                            <div className="ws-kpi-card ws-am">
//                               <div className="ws-kpi-label">At Risk (21d+ above baseline)</div>
//                                  <div className="ws-kpi-val ws-amber">{fmtNum(kpis.atRisk)}</div>
//                               <div className="ws-kpi-delta">Personal avg exceeded</div>
//                            </div>
//                            <div className="ws-kpi-card ws-rd">
//                               <div className="ws-kpi-label">Churned (60d+)</div>
//                                  <div className="ws-kpi-val ws-red">{fmtNum(kpis.churned60d)}</div>
//                               <div className="ws-kpi-delta">Last wash 60+ days ago</div>
//                            </div>
//                         </div>

//                         <div className="ws-filter-row">
//                            <select className="ws-f-select" value={segmentFilter} onChange={(e) => setSegmentFilter(e.target.value)}>
//                               {segmentOptions.map((s) => <option key={s} value={s}>{s}</option>)}
//                            </select>
//                            <select className="ws-f-select" value={carTypeFilter} onChange={(e) => setCarTypeFilter(e.target.value)}>
//                               {carTypeOptions.map((c) => <option key={c} value={c}>{c}</option>)}
//                            </select>
//                            <select className="ws-f-select" value={cityFilter} onChange={(e) => setCityFilter(e.target.value)}>
//                               {cityOptions.map((c) => <option key={c} value={c}>{c}</option>)}
//                            </select>
//                            <input
//                               className="ws-f-input ws-ml"
//                               placeholder="Name, email, plate…"
//                               style={{ width: 180 }}
//                               value={search}
//                               onChange={(e) => setSearch(e.target.value)}
//                            />
//                            <button className="ws-btn-ex" onClick={exportSegmentCSV}>↓ Export segment</button>
//                         </div>

//                         <table className="ws-tbl">
//                            <thead>
//                               <tr>
//                                  <th>Customer</th>
//                                  <th>Vehicle</th>
//                                  <th>City</th>
//                                  <th className="ws-r">Washes</th>
//                                  <th className="ws-r">Avg Interval</th>
//                                  <th className="ws-r">Last Wash</th>
//                                  <th className="ws-r">Lifetime Spend</th>
//                                  <th>Preferred Service</th>
//                                  <th>Segment</th>
//                               </tr>
//                            </thead>
//                            <tbody>
//                               {filteredCustomers.length === 0 ? (
//                                  <tr>
//                                     <td colSpan={9} style={{ textAlign: 'center', color: '#aaa', padding: '18px 10px' }}>
//                                        No customers match the current filters.
//                                     </td>
//                                  </tr>
//                               ) : filteredCustomers.map((c) => (
//                                  <tr key={c.id}>
//                                     <td>
//                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//                                           <div className="ws-avatar" style={{ background: c.avatarBg, color: c.avatarColor }}>{c.initials}</div>
//                                           <div>
//                                              <div style={{ fontWeight: 600, fontSize: 11 }}>{c.name}</div>
//                                              <div style={{ fontSize: 9, color: '#aaa' }}>{c.email}</div>
//                                           </div>
//                                        </div>
//                                     </td>
//                                     <td>
//                                        <div style={{ fontSize: 11 }}>{c.vehicle}</div>
//                                        <div><span className="ws-plate">{c.plate}</span> <span style={{ fontSize: 9, color: '#888' }}>{c.carType}</span></div>
//                                     </td>
//                                     <td style={{ fontSize: 11 }}>{c.city}</td>
//                                     <td className="ws-r" style={{ fontWeight: 700, color: c.segment === 'churned' ? '#888' : '#4a3db8' }}>{c.washes}</td>
//                                     <td className="ws-r" style={{ fontSize: 11 }}>
//                                        {c.avgIntervalDays != null ? `${c.avgIntervalDays} days` : <span style={{ color: '#ccc' }}>—</span>}
//                                     </td>
//                                     <td
//                                        className="ws-r"
//                                        style={{
//                                           fontSize: 11,
//                                           color: c.segment === 'at-risk' ? '#92400E' : c.segment === 'churned' ? '#991b1b' : '#111',
//                                        }}
//                                     >
//                                        {c.lastWash}
//                                     </td>
//                                     <td className="ws-r" style={{ fontWeight: 700, color: c.segment === 'churned' ? '#888' : '#111' }}>
//                                        {fmtAED(c.lifetimeSpend)}
//                                     </td>
//                                     <td style={{ fontSize: 11, color: c.segment === 'churned' ? '#888' : '#4a3db8' }}>{c.preferredService}</td>
//                                     <td>
//                                        <span
//                                           className={`ws-pill ${segmentPillClass(c.segment)}`}
//                                           style={c.segment === 'churned' ? { background: '#fee2e2', color: '#991b1b' } : undefined}
//                                        >
//                                           {c.segmentLabel}
//                                        </span>
//                                     </td>
//                                  </tr>
//                               ))}
//                            </tbody>
//                         </table>
//                      </div>

//                      {/* ── Right panel ── */}
//                      <div className="ws-right-panel">
//                         <div className="ws-rp-title">Segments</div>
//                         <div style={{ display: 'flex', flexDirection: 'column', gap: 5, marginBottom: 12 }}>
//                            {segmentSummary.map((s) => (
//                               <div
//                                  key={s.key}
//                                  style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 10px', background: s.bg, borderRadius: 7, cursor: 'pointer' }}
//                                  onClick={() => setSegmentFilter(s.label)}
//                               >
//                                  <span style={{ fontSize: 10, fontWeight: 700, color: s.color }}>{s.label}</span>
//                                  <span style={{ fontSize: 11, fontWeight: 700, color: s.color }}>{s.count}</span>
//                               </div>
//                            ))}
//                         </div>

//                         <div className="ws-divider"></div>
//                         <div className="ws-rp-title">Fleet Profile</div>
//                         {fleetProfile.length > 0 ? fleetProfile.map((f) => (
//                            <div className="ws-mix-row" key={f.label}>
//                               <span className="ws-mix-label">{f.label}</span>
//                               <div className="ws-mix-track"><div className="ws-mix-fill" style={{ width: `${f.widthPct}%` }}></div></div>
//                               <span className="ws-mix-val">{f.sharePct}%</span>
//                            </div>
//                         )) : (
//                            <div style={{ fontSize: 10, color: '#aaa', marginBottom: 8 }}>No vehicle data yet.</div>
//                         )}

//                         {carTypeSplit.length > 0 && (
//                            <>
//                               <div className="ws-divider"></div>
//                               <div className="ws-rp-title">Car Type Split</div>
//                               {carTypeSplit.map((c) => (
//                                  <div className="ws-mix-row" key={c.label}>
//                                     <span className="ws-mix-label">{c.label}</span>
//                                     <div className="ws-mix-track"><div className="ws-mix-fill" style={{ width: `${c.pct}%`, background: '#92400E' }}></div></div>
//                                     <span className="ws-mix-val" style={{ color: '#92400E' }}>{c.pct}%</span>
//                                  </div>
//                               ))}
//                            </>
//                         )}

//                         <div className="ws-divider"></div>
//                         <div className="ws-rp-title">Quick Actions</div>
//                         <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
//                            <button className="ws-btn-sm ws-btn-gh" style={{ textAlign: 'left', fontSize: 10 }} onClick={notifyAtRisk}>
//                               📣 Notify at-risk segment
//                            </button>
//                            <button className="ws-btn-sm ws-btn-gh" style={{ textAlign: 'left', fontSize: 10 }} onClick={exportVIP}>
//                               📤 Export VIP list CSV
//                            </button>
//                         </div>
//                      </div>
//                   </div>
//                )}
//             </div>
//          </div>
//       </div>
//    );
// }

// export default Crm;
import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import AdminSidebar from 'admin/sidebar/AdminSidebar';
import axios from 'axios';
import './Crm.css';

const fmtAED = (n) => `AED ${Number(n || 0).toLocaleString('en-US', { maximumFractionDigits: 2 })}`;
const fmtNum = (n) => Number(n || 0).toLocaleString('en-US');

const API_BASE = process.env.REACT_APP_API_URL || 'https://production.washta.com';
const DASHBOARD_V2_URL = `${API_BASE}/api/admin/v2/dashboard`;

const EMPTY_KPIS = {
   totalCustomers: 0,
   active30d: 0,
   atRisk: 0,
   churned60d: 0,
   newThisMonth: 0,
};

const getInitials = (name = '') => {
   const parts = String(name).trim().split(/\s+/).filter(Boolean);
   if (parts.length === 0) return 'NA';
   return parts.slice(0, 2).map((part) => part[0]).join('').toUpperCase();
};

const toNumber = (value) => {
   if (typeof value === 'number') return value;
   const parsed = Number(value || 0);
   return Number.isFinite(parsed) ? parsed : 0;
};

const formatDateLabel = (value) => {
   if (!value) return '—';
   const date = new Date(value);
   if (Number.isNaN(date.getTime())) return '—';
   return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};

const daysBetween = (older, newer) => {
   if (!older || !newer) return null;
   const diff = newer.getTime() - older.getTime();
   if (!Number.isFinite(diff) || diff < 0) return null;
   return Math.round(diff / (1000 * 60 * 60 * 24));
};

const deriveSegment = (daysSinceLastWash, totalOrders) => {
   if (totalOrders >= 10) return { key: 'vip', label: 'VIP · 10+ washes', bg: '#f0eeff', color: '#4a3db8' };
   if (daysSinceLastWash != null && daysSinceLastWash >= 60) return { key: 'churned', label: 'Churned · 60d+', bg: '#fee2e2', color: '#991b1b' };
   if (daysSinceLastWash != null && daysSinceLastWash >= 21) return { key: 'at-risk', label: 'At Risk · 21d+', bg: '#fef3c7', color: '#92400E' };
   return { key: 'active', label: 'Active · 30d', bg: '#e0f2ea', color: '#1a6641' };
};

const buildCustomerRows = (orders = []) => {
   const byCustomer = new Map();

   orders.forEach((order) => {
      const customer = order.customerId || {};
      const customerId = customer._id || order.customerId?._id || order.customerId;
      if (!customerId) return;

      const customerName = customer.username || customer.fullName || customer.fullname || customer.name || order.customerName || 'Unknown Customer';
      const customerEmail = customer.email || order.customerEmail || '—';

      const createdAt = new Date(order.createdAt || order.date || Date.now());
      const current = byCustomer.get(String(customerId)) || {
         id: String(customerId),
         name: customerName,
         email: customerEmail,
         avatar: customer.avatar || customer.resizedAvatar || '',
         vehicle: order.vehicleId?.vehicleName || order.vehicleId?.vehicleModel || order.vehicleId?.vehicleManufacturer || order.vehicleName || '—',
         plate: order.vehicleId?.vehiclePlateNumber || order.plate || '—',
         carType: order.vehicleId?.vehicleType || order.vehicleId?.vehicleModel || order.vehicleId?.vehicleManufacturer || order.vehicleType || '—',
         city: order.serviceLocation?.city || order.serviceLocation?.text || order.shopId?.location?.text || '—',
         washes: 0,
         totalSpend: 0,
         dates: [],
         services: new Map(),
      };

      current.washes += 1;
      current.totalSpend += toNumber(order.cost || order.finalCost || order.shopPrice || 0);
      current.dates.push(createdAt);

      current.name = customerName || current.name;
      current.email = customerEmail || current.email;

      if (order.vehicleId) {
         current.vehicle = order.vehicleId.vehicleName || order.vehicleId.vehicleModel || current.vehicle;
         current.plate = order.vehicleId.vehiclePlateNumber || current.plate;
         current.carType = order.vehicleId.vehicleType || current.carType;
      }

      const serviceName = order.serviceName || order.shopId?.service || order.serviceVariant?.variantName || 'Other';
      current.services.set(serviceName, (current.services.get(serviceName) || 0) + 1);
      byCustomer.set(String(customerId), current);
   });

   return Array.from(byCustomer.values())
      .map((customer) => {
         const sortedDates = customer.dates.sort((a, b) => a.getTime() - b.getTime());
         const lastWashDate = sortedDates[sortedDates.length - 1] || null;
         const gaps = [];
         for (let i = 1; i < sortedDates.length; i++) {
            const gap = daysBetween(sortedDates[i - 1], sortedDates[i]);
            if (gap != null) gaps.push(gap);
         }
         const avgIntervalDays = gaps.length ? Math.round(gaps.reduce((sum, gap) => sum + gap, 0) / gaps.length) : null;
         const daysSinceLastWash = lastWashDate ? daysBetween(lastWashDate, new Date()) : null;
         const segment = deriveSegment(daysSinceLastWash, customer.washes);
         const topService = Array.from(customer.services.entries()).sort((a, b) => b[1] - a[1])[0]?.[0] || '—';

         return {
            id: customer.id,
            initials: getInitials(customer.name),
            avatarBg: segment.bg,
            avatarColor: segment.color,
            name: customer.name,
            email: customer.email,
            vehicle: customer.vehicle,
            plate: customer.plate,
            carType: customer.carType,
            city: customer.city,
            washes: customer.washes,
            avgIntervalDays,
            lastWash: formatDateLabel(lastWashDate),
            lifetimeSpend: customer.totalSpend,
            preferredService: topService,
            segment: segment.key,
            segmentLabel: segment.label,
            lastWashDays: daysSinceLastWash,
         };
      })
      .sort((a, b) => b.lifetimeSpend - a.lifetimeSpend);
};

const RATING_THRESHOLD = 4.0;

// Build real fleet profile from orders
const buildFleetProfile = (orders = []) => {
   const counts = {};
   orders.forEach((order) => {
      const v = order.vehicleId;
      if (!v) return;
      const make = v.vehicleManufacturer || '';
      const model = v.vehicleName || v.vehicleModel || '';
      const label = [make, model].filter(Boolean).join(' ').trim() || 'Unknown';
      counts[label] = (counts[label] || 0) + 1;
   });
   const total = Object.values(counts).reduce((s, n) => s + n, 0);
   if (total === 0) return [];
   return Object.entries(counts)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 6)
      .map(([label, count]) => ({
         label,
         count,
         sharePct: Math.round((count / total) * 100),
         widthPct: Math.round((count / total) * 100),
      }));
};

// Build real car type distribution
const buildCarTypeSplit = (orders = []) => {
   const counts = {};
   orders.forEach((order) => {
      const type = order.vehicleId?.vehicleType || 'Unknown';
      counts[type] = (counts[type] || 0) + 1;
   });
   const total = Object.values(counts).reduce((s, n) => s + n, 0);
   if (total === 0) return [];
   return Object.entries(counts)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 6)
      .map(([label, count]) => ({
         label,
         count,
         pct: Math.round((count / total) * 100),
      }));
};

// ── Skeleton loader — mirrors the real page layout ───────────────────
const CrmSkeleton = () => (
   <div style={{ display: 'flex', width: '100%' }}>
      <div className="ws-view-block" style={{ flex: 1, minWidth: 0 }}>
         <div className="ws-skel ws-skel-title"></div>
         <div className="ws-skel ws-skel-sub"></div>

         <div className="ws-kpi-strip ws-kpi-4">
            {Array.from(new Array(4)).map((_, i) => (
               <div className="ws-kpi-card" key={i}>
                  <div className="ws-skel ws-skel-line-sm"></div>
                  <div className="ws-skel ws-skel-line-lg" style={{ marginTop: 8 }}></div>
                  <div className="ws-skel ws-skel-line-sm" style={{ marginTop: 8, width: '70%' }}></div>
               </div>
            ))}
         </div>

         <div style={{ display: 'flex', gap: 7, marginBottom: 14 }}>
            {Array.from(new Array(4)).map((_, i) => (
               <div key={i} className="ws-skel ws-skel-pill"></div>
            ))}
         </div>

         <div className="ws-skel ws-skel-block" style={{ height: 260 }}></div>
      </div>
      <div className="ws-right-panel">
         <div className="ws-skel ws-skel-line-sm" style={{ width: 70, marginBottom: 10 }}></div>
         {Array.from(new Array(4)).map((_, i) => (
            <div key={i} className="ws-skel ws-skel-line-md" style={{ marginBottom: 6 }}></div>
         ))}
      </div>
   </div>
);

const Crm = () => {
   const navigate = useNavigate();
   const [loading, setLoading] = useState(true);
   const [kpis, setKpis] = useState(EMPTY_KPIS);
   const [customers, setCustomers] = useState([]);
   const [fleetProfile, setFleetProfile] = useState([]);
   const [carTypeSplit, setCarTypeSplit] = useState([]);
   const [rawOrders, setRawOrders] = useState([]);
   const [segmentFilter, setSegmentFilter] = useState('All Segments');
   const [carTypeFilter, setCarTypeFilter] = useState('All Car Types');
   const [cityFilter, setCityFilter] = useState('All Cities');
   const [search, setSearch] = useState('');

   useEffect(() => {
      window.scrollTo(0, 0);

      const fetchData = async () => {
         try {
            setLoading(true);
            const token = localStorage.getItem('accessTokenAdmin');
            if (!token) {
               navigate('/');
               return;
            }

            const headers = { Authorization: `Bearer ${token}` };
            const [customerStatsRes, ordersRes] = await Promise.all([
               axios.get(`${DASHBOARD_V2_URL}/customers`, { headers }).catch(() => null),
               axios.get(`${DASHBOARD_V2_URL}/crm-customers`, { headers }).catch(() => null),
            ]);

            const stats = customerStatsRes?.data?.data?.kpis || {};
            setKpis({
               totalCustomers: toNumber(stats.totalCustomers?.value),
               active30d: toNumber(stats.activeCustomers?.value),
               atRisk: toNumber(stats.atRiskCustomers?.value),
               churned60d: toNumber(stats.churnedCustomers?.value),
               newThisMonth: 0,
            });

            const orders = ordersRes?.data?.data?.orders || [];
            const liveCustomers = buildCustomerRows(orders);
            setCustomers(liveCustomers);
            setRawOrders(orders);
            setFleetProfile(buildFleetProfile(orders));
            setCarTypeSplit(buildCarTypeSplit(orders));
         } catch (error) {
            console.error('Error loading CRM data:', error);
         } finally {
            setLoading(false);
         }
      };

      fetchData();
   }, []);

   const segmentOptions = ['All Segments', 'Active · 30d', 'At Risk · 21d+', 'Churned · 60d+', 'VIP · 10+ washes'];
   const carTypeOptions = useMemo(
      () => ['All Car Types', ...Array.from(new Set(customers.map((c) => c.carType).filter(Boolean)))],
      [customers]
   );
   const cityOptions = useMemo(
      () => ['All Cities', ...Array.from(new Set(customers.map((c) => c.city).filter(Boolean)))],
      [customers]
   );

   const segmentKeyMap = {
      'Active · 30d': 'active',
      'At Risk · 21d+': 'at-risk',
      'Churned · 60d+': 'churned',
      'VIP · 10+ washes': 'vip',
   };

   const filteredCustomers = useMemo(() => {
      return customers
         .filter((c) => segmentFilter === 'All Segments' || c.segment === segmentKeyMap[segmentFilter])
         .filter((c) => carTypeFilter === 'All Car Types' || c.carType === carTypeFilter)
         .filter((c) => cityFilter === 'All Cities' || c.city === cityFilter)
         .filter((c) => {
            if (!search.trim()) return true;
            const q = search.trim().toLowerCase();
            return c.name.toLowerCase().includes(q) || c.email.toLowerCase().includes(q) || c.plate.toLowerCase().includes(q);
         });
   }, [customers, segmentFilter, carTypeFilter, cityFilter, search]);

   const segmentSummary = useMemo(() => {
      const grouped = customers.reduce((acc, customer) => {
         acc[customer.segment] = (acc[customer.segment] || 0) + 1;
         return acc;
      }, {});

      return [
         { key: 'active', label: 'Active · 30d', count: grouped.active || 0, bg: '#e0f2ea', color: '#1a6641' },
         { key: 'at-risk', label: 'At Risk · 21d+', count: grouped['at-risk'] || 0, bg: '#fef3c7', color: '#92400E' },
         { key: 'churned', label: 'Churned · 60d+', count: grouped.churned || 0, bg: '#fee2e2', color: '#991b1b' },
         { key: 'vip', label: 'VIP · 10+ washes', count: grouped.vip || 0, bg: '#f0eeff', color: '#4a3db8' },
      ];
   }, [customers]);

   const exportSegmentCSV = () => {
      const header = ['Customer', 'Email', 'Vehicle', 'Plate', 'Car Type', 'City', 'Washes', 'Avg Interval (days)', 'Last Wash', 'Lifetime Spend', 'Preferred Service', 'Segment'];
      const lines = filteredCustomers.map((c) => [
         c.name, c.email, c.vehicle, c.plate, c.carType, c.city, c.washes,
         c.avgIntervalDays ?? '—', c.lastWash, c.lifetimeSpend, c.preferredService, c.segmentLabel,
      ]);
      const csv = [header, ...lines].map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(',')).join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'washta-crm-segment.csv';
      a.click();
      URL.revokeObjectURL(url);
   };

   const notifyAtRisk = () => {
      alert(`Notify ${kpis.atRisk} at-risk customers — hook this up to your notifications API.`);
   };

   const exportVIP = () => {
      const vipCustomers = customers.filter((c) => c.segment === 'vip');
      const header = ['Customer', 'Email', 'Washes', 'Lifetime Spend'];
      const lines = vipCustomers.map((c) => [c.name, c.email, c.washes, c.lifetimeSpend]);
      const csv = [header, ...lines].map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(',')).join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'washta-vip-list.csv';
      a.click();
      URL.revokeObjectURL(url);
   };

   const segmentPillClass = (segment) => {
      if (segment === 'active') return 'ws-p-active';
      if (segment === 'at-risk') return 'ws-p-pending';
      return 'ws-p-refund';
   };

   return (
      <div className='mainDiv-all-sideBar'>
         <div className='div-sidebar'>
            <AdminSidebar />
         </div>
         <div className='div-Dashbaord' style={{ padding: 0 ,background:'white'}}>
            <div className="dashboard ws-crm-dashboard">
               {loading ? (
                  <CrmSkeleton />
               ) : (
                  <div style={{ display: 'flex', width: '100%', minWidth: 0 }}>
                     {/* ── Main column ── */}
                     <div className="ws-view-block" style={{ flex: 1, minWidth: 0 }}>
                        <div className="ws-view-title">Customer CRM</div>
                        <div className="ws-view-sub">
                           Platform-wide customer intelligence. Churn signals based on each customer's personal wash
                           interval baseline — not a fixed threshold.
                        </div>

                        <div className="ws-kpi-strip ws-kpi-4">
                           <div className="ws-kpi-card ws-hl">
                              <div className="ws-kpi-label">Total Customers</div>
                                 <div className="ws-kpi-val ws-purple">{fmtNum(kpis.totalCustomers)}</div>
                                 <div className="ws-kpi-delta ws-up">Live from customer intelligence API</div>
                           </div>
                           <div className="ws-kpi-card ws-gr">
                              <div className="ws-kpi-label">Active (30d)</div>
                                 <div className="ws-kpi-val ws-green">{fmtNum(kpis.active30d)}</div>
                                 <div className="ws-kpi-delta">{kpis.totalCustomers ? Math.round((kpis.active30d / kpis.totalCustomers) * 100) : 0}% of base</div>
                           </div>
                           <div className="ws-kpi-card ws-am">
                              <div className="ws-kpi-label">At Risk (21d+ above baseline)</div>
                                 <div className="ws-kpi-val ws-amber">{fmtNum(kpis.atRisk)}</div>
                              <div className="ws-kpi-delta">Personal avg exceeded</div>
                           </div>
                           <div className="ws-kpi-card ws-rd">
                              <div className="ws-kpi-label">Churned (60d+)</div>
                                 <div className="ws-kpi-val ws-red">{fmtNum(kpis.churned60d)}</div>
                              <div className="ws-kpi-delta">Last wash 60+ days ago</div>
                           </div>
                        </div>

                        <div className="ws-filter-row">
                           <select className="ws-f-select" value={segmentFilter} onChange={(e) => setSegmentFilter(e.target.value)}>
                              {segmentOptions.map((s) => <option key={s} value={s}>{s}</option>)}
                           </select>
                           <select className="ws-f-select" value={carTypeFilter} onChange={(e) => setCarTypeFilter(e.target.value)}>
                              {carTypeOptions.map((c) => <option key={c} value={c}>{c}</option>)}
                           </select>
                           <select className="ws-f-select" value={cityFilter} onChange={(e) => setCityFilter(e.target.value)}>
                              {cityOptions.map((c) => <option key={c} value={c}>{c}</option>)}
                           </select>
                           <input
                              className="ws-f-input ws-ml"
                              placeholder="Name, email, plate…"
                              style={{ width: 180 }}
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                           />
                           <button className="ws-btn-ex" onClick={exportSegmentCSV}>↓ Export segment</button>
                        </div>

                        <table className="ws-tbl">
                           <thead>
                              <tr>
                                 <th>Customer</th>
                                 <th>Vehicle</th>
                                 <th>City</th>
                                 <th className="ws-r">Washes</th>
                                 <th className="ws-r">Avg Interval</th>
                                 <th className="ws-r">Last Wash</th>
                                 <th className="ws-r">Lifetime Spend</th>
                                 <th>Preferred Service</th>
                                 <th>Segment</th>
                              </tr>
                           </thead>
                           <tbody>
                              {filteredCustomers.length === 0 ? (
                                 <tr>
                                    <td colSpan={9} style={{ textAlign: 'center', color: '#aaa', padding: '18px 10px' }}>
                                       No customers match the current filters.
                                    </td>
                                 </tr>
                              ) : filteredCustomers.map((c) => (
                                 <tr key={c.id}>
                                    <td>
                                       <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                          <div className="ws-avatar" style={{ background: c.avatarBg, color: c.avatarColor }}>{c.initials}</div>
                                          <div>
                                             <div style={{ fontWeight: 600, fontSize: 11 }}>{c.name}</div>
                                             <div style={{ fontSize: 9, color: '#aaa' }}>{c.email}</div>
                                          </div>
                                       </div>
                                    </td>
                                    <td>
                                       <div style={{ fontSize: 11 }}>{c.vehicle}</div>
                                       <div><span className="ws-plate">{c.plate}</span> <span style={{ fontSize: 9, color: '#888' }}>{c.carType}</span></div>
                                    </td>
                                    <td style={{ fontSize: 11 }}>{c.city}</td>
                                    <td className="ws-r" style={{ fontWeight: 700, color: c.segment === 'churned' ? '#888' : '#4a3db8' }}>{c.washes}</td>
                                    <td className="ws-r" style={{ fontSize: 11 }}>
                                       {c.avgIntervalDays != null ? `${c.avgIntervalDays} days` : <span style={{ color: '#ccc' }}>—</span>}
                                    </td>
                                    <td
                                       className="ws-r"
                                       style={{
                                          fontSize: 11,
                                          color: c.segment === 'at-risk' ? '#92400E' : c.segment === 'churned' ? '#991b1b' : '#111',
                                       }}
                                    >
                                       {c.lastWash}
                                    </td>
                                    <td className="ws-r" style={{ fontWeight: 700, color: c.segment === 'churned' ? '#888' : '#111' }}>
                                       {fmtAED(c.lifetimeSpend)}
                                    </td>
                                    <td style={{ fontSize: 11, color: c.segment === 'churned' ? '#888' : '#4a3db8' }}>{c.preferredService}</td>
                                    <td>
                                       <span
                                          className={`ws-pill ${segmentPillClass(c.segment)}`}
                                          style={c.segment === 'churned' ? { background: '#fee2e2', color: '#991b1b' } : undefined}
                                       >
                                          {c.segmentLabel}
                                       </span>
                                    </td>
                                 </tr>
                              ))}
                           </tbody>
                        </table>
                     </div>

                     {/* ── Right panel ── */}
                     <div className="ws-right-panel">
                        <div className="ws-rp-title">Segments</div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 5, marginBottom: 12 }}>
                           {segmentSummary.map((s) => (
                              <div
                                 key={s.key}
                                 style={{ display: 'flex', justifyContent: 'space-between', padding: '7px 10px', background: s.bg, borderRadius: 7, cursor: 'pointer' }}
                                 onClick={() => setSegmentFilter(s.label)}
                              >
                                 <span style={{ fontSize: 10, fontWeight: 700, color: s.color }}>{s.label}</span>
                                 <span style={{ fontSize: 11, fontWeight: 700, color: s.color }}>{s.count}</span>
                              </div>
                           ))}
                        </div>

                        <div className="ws-divider"></div>
                        <div className="ws-rp-title">Fleet Profile</div>
                        {fleetProfile.length > 0 ? fleetProfile.map((f) => (
                           <div className="ws-mix-row" key={f.label}>
                              <span className="ws-mix-label">{f.label}</span>
                              <div className="ws-mix-track"><div className="ws-mix-fill" style={{ width: `${f.widthPct}%` }}></div></div>
                              <span className="ws-mix-val">{f.sharePct}%</span>
                           </div>
                        )) : (
                           <div style={{ fontSize: 10, color: '#aaa', marginBottom: 8 }}>No vehicle data yet.</div>
                        )}

                        {carTypeSplit.length > 0 && (
                           <>
                              <div className="ws-divider"></div>
                              <div className="ws-rp-title">Car Type Split</div>
                              {carTypeSplit.map((c) => (
                                 <div className="ws-mix-row" key={c.label}>
                                    <span className="ws-mix-label">{c.label}</span>
                                    <div className="ws-mix-track"><div className="ws-mix-fill" style={{ width: `${c.pct}%`, background: '#92400E' }}></div></div>
                                    <span className="ws-mix-val" style={{ color: '#92400E' }}>{c.pct}%</span>
                                 </div>
                              ))}
                           </>
                        )}

                        <div className="ws-divider"></div>
                        <div className="ws-rp-title">Quick Actions</div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                           <button className="ws-btn-sm ws-btn-gh" style={{ textAlign: 'left', fontSize: 10 }} onClick={notifyAtRisk}>
                              📣 Notify at-risk segment
                           </button>
                           <button className="ws-btn-sm ws-btn-gh" style={{ textAlign: 'left', fontSize: 10 }} onClick={exportVIP}>
                              📤 Export VIP list CSV
                           </button>
                        </div>
                     </div>
                  </div>
               )}
            </div>
         </div>
      </div>
   );
}

export default Crm;